/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContractBlockDto } from '../../models/contract-block-dto';

export interface ContractIsContractBlocked$Params {
  admissionPlannedDate?: string;
}

export function contractIsContractBlocked(http: HttpClient, rootUrl: string, params?: ContractIsContractBlocked$Params, context?: HttpContext): Observable<StrictHttpResponse<ContractBlockDto>> {
  const rb = new RequestBuilder(rootUrl, contractIsContractBlocked.PATH, 'get');
  if (params) {
    rb.query('admissionPlannedDate', params.admissionPlannedDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContractBlockDto>;
    })
  );
}

contractIsContractBlocked.PATH = '/v1/Contract/IsContractBlocked';
